import { useCallback } from "react";
import styled from "styled-components";
import { Button, Label } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { dayjs } from "@sablier/v2-mixins";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    width: 100%;
    ${Actions} {
      ${(props) => props.theme.styles.row}
      & {
        flex-wrap: wrap;
        gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
        width: 100%;
      }
    }
  }
`;

type Suggestion = {
  title: string;
  purpose: "day" | "hour" | "minute";
  value: number;
};

interface Props {
  setValue: (value?: string) => void;
}

function Suggested({ setValue }: Props) {
  const { t } = useT();
  const suggested: Suggestion[] = [
    {
      title: t("modalCards.moment.suggestion.year"),
      purpose: "day",
      value: 365,
    },
    {
      title: t("modalCards.moment.suggestion.3months"),
      purpose: "day",
      value: 90,
    },
    {
      title: t("modalCards.moment.suggestion.month"),
      purpose: "day",
      value: 30,
    },
    {
      title: t("modalCards.moment.suggestion.15days"),
      purpose: "day",
      value: 15,
    },

    {
      title: t("modalCards.moment.suggestion.tomorrow"),
      purpose: "day",
      value: 1,
    },
    {
      title: t("modalCards.moment.suggestion.12hours"),
      purpose: "hour",
      value: 12,
    },
    {
      title: t("modalCards.moment.suggestion.hour"),
      purpose: "hour",
      value: 1,
    },
  ];

  const onSuggest = useCallback(
    (action: Suggestion) => {
      const result = dayjs().add(action.value, action.purpose).second(0);
      setValue(result.valueOf().toString());
    },
    [setValue],
  );

  return (
    <Wrapper>
      <Label value={t("words.suggested")} />
      <Actions>
        {suggested.map((action) => (
          <Button
            key={action.title}
            accent={"dark400"}
            appearance={"outline"}
            onClick={() => {
              onSuggest(action);
            }}
            isMini
            title={action.title}
          />
        ))}
      </Actions>
    </Wrapper>
  );
}

export default Suggested;
